<template>
  <c-container
    padding-size="xs"
    :style="{ background: 'white' }"
  >
    <c-input
      v-model:value="search"
      autofocus
      show-border
      show-background
      placeholder="Search for databases..."
      show-outline
      :style="{ marginBottom: '2rem' }"
    />
    <template v-if="databasesLoading">
      <c-icon
        type="loading"
        spin
        size="28"
        :color="$colors.grey.lighten1"
      />
    </template>
    <template v-else>
      <div
        v-if="databases.length === 0"
        :style="{ color: $colors.grey.base }"
      >
        Nothing found. Did you give Notix the necessary access rights?
<!--        eslint-disable-->
        If not you can <a :style="{ textDecoration: 'underline' }" @click="connectToNotion">click here</a>.
        <!--        eslint-enable-->
      </div>
      <c-card-item
        v-for="(database, idx) in databases"
        :key="idx"
        :title="database.name"
        :icon="database.icon === null ? 'file-text' : database.icon"
        :icon-type="database.icon === null ? 'internal' : 'notion'"
        align-top
        :style="{ borderRadius: '.3rem', padding: '.6rem 1.2rem' }"
        @click="addTemplate(database.id)"
      >
        <template #subTitle>
          <div :style="{ color: $colors.grey.base }">
            {{ workspace.name }}
            <template v-if="database.parentType !== 'workspace'">
              <template v-if="database.grandParentIsWorkspace">
                / {{ database.parentName }}
              </template>
              <template v-else>
                / ... / {{ database.parentName }}
              </template>
            </template>
          </div>
        </template>
      </c-card-item>
    </template>
  </c-container>
</template>

<script>
import CCardItem from 'shared/components/CCardItem.vue';
import CContainer from 'shared/components/CContainer.vue';
import CIcon from 'shared/components/CIcon.vue';
import CInput from 'shared/components/CInput.vue';
import { NOTION_DATABASE_SERVICE, TEMPLATE_SERVICE, USER_SERVICE } from 'shared/constants';
import useDebounce from 'shared/services/debounce';
import { httpsCallable } from 'shared/services/firebase';
import { computed, inject } from 'vue';

export default {
  name: 'SeeDatabases',
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    createWithoutTemplate: {
      type: Boolean,
      default: false,
    },
  },
  components: { CCardItem, CContainer, CInput, CIcon },
  data() {
    return {
      search: '',
      searchResults: [],
    };
  },
  setup() {
    const userService = inject(USER_SERVICE);
    const templateService = inject(TEMPLATE_SERVICE);
    const notionDatabaseService = inject(NOTION_DATABASE_SERVICE);
    const { debounce } = useDebounce();
    return {
      currentUser: userService.currentUser,
      templateService,
      debounce,
      notionDatabaseService,
      databasesRaw: notionDatabaseService.databases,
      databasesLoading: computed(() => notionDatabaseService.loading.value || notionDatabaseService.searchByNameLoading.value),
    };
  },
  computed: {
    databases() {
      if (this.search === '') {
        return this.databasesRaw;
      }

      return this.searchResults;
    },
  },
  emits: ['edit-template', 'use-template'],
  methods: {
    async getNotionAuthURL() {
      const notionAuthURL = httpsCallable(this.$functions, 'notionAuthURL');
      const res = await notionAuthURL();
      return res.data;
    },
    async connectToNotion() {
      this.connectLoading = true;
      const res = await this.getNotionAuthURL();
      window.open(res, '_blank');
      this.connectLoading = false;
    },
    async addTemplate(databaseId) {
      const database = await this.notionDatabaseService.getSingleNoParent(databaseId);
      const dataObj = this.templateService.writeDefaultTemplate(database);
      if (this.createWithoutTemplate) {
        const templateId = this.templateService.addTmpTemplate(dataObj);
        this.$emit('use-template', templateId);
        return;
      }
      const templateId = await this.templateService.addSingle(dataObj);
      this.$emit('edit-template', templateId);
    },
  },
  watch: {
    async search() {
      const searchWrapper = async () => {
        this.searchResults = await this.notionDatabaseService.searchByName(this.search);
      };
      if (this.search !== '') {
        this.debounce(searchWrapper, 500);
      }
    },
  },
};
</script>

<style scoped type="text/scss">
</style>
